import { GetDocumentMetadataRequest } from '@cs-cms/types';

export const documentsKeys = {
  all: ['documents'] as const,
  document: (contentType?: string, documentId?: string) => [...documentsKeys.all, contentType, documentId] as const,
  documentMetadata: (dto?: GetDocumentMetadataRequest) => [...documentsKeys.all, 'documentMetadata', dto] as const
};
